module.exports = __webpack_public_path__ + "img/Pikachu.0acc493e.jpg";